// Muestra la barra flotante de "Agregar al carrito" cuando el boton real
// de compra sale de la vista (scroll hacia abajo), la esconde cuando vuelve
// a estar visible. Al hacer click en la barra, dispara el boton real en vez
// de duplicar el formulario -- una sola fuente de verdad para variante/qty.
(function () {
  function init() {
    const bar = document.querySelector('[data-rechilero-sticky-atc]');
    const realButton = document.querySelector('.product-form__buttons button[name="add"]');
    if (!bar || !realButton) return;

    const barButton = bar.querySelector('[data-rechilero-sticky-atc-button]');
    barButton.addEventListener('click', () => realButton.click());

    const observer = new IntersectionObserver(
      (entries) => {
        const realButtonVisible = entries[0].isIntersecting;
        bar.hidden = false;
        bar.classList.toggle('rechilero-sticky-atc--visible', !realButtonVisible);
      },
      { rootMargin: '0px 0px -10% 0px' }
    );
    observer.observe(realButton);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
